import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBlock: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"block, workspace"} maskId="square-filled-radius-0-stroke-1-IconBlock"><path fillRule="evenodd" clipRule="evenodd" d="M4 3H20V20H22V21H2V20H4V3ZM8 7H11V8H8V7ZM13 7H16V8H13V7ZM8 11H11V12H8V11ZM13 11H16V12H13V11ZM8 15H11V16H8V15ZM13 15H16V16H13V15Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBlock;
